import type { StyleSystemProps } from '@withjoy/joykit';
import { styled, Box } from '@withjoy/joykit';

export const StyledPage = styled(Box)``;

const pageStyles: StyleSystemProps = {
  width: '100%',
};

export const styles = {
  page: pageStyles,
};
